<template>
  <v-card>
      <v-card-title>Загрузка (обновление) списка должников</v-card-title>
      <v-card-text>
        <v-row v-if="null == debtorsUploadId" justify="center">
            <v-col cols="4">
                  <social-debtors-upload-form @upload="onUpload"></social-debtors-upload-form>
                  Скачать пустой шаблон для заполнения с инструкцией тут <v-icon color="blue" large @click="onDownloadTemplate">mdi-download</v-icon>
                  <!-- <v-btn color="success" @click="onDownloadTemplate">Скачать шаблон</v-btn> -->
            </v-col>
        </v-row> 
        <v-row v-else>
            <v-col cols="2">
                <v-btn v-if="null != debtorsUploadId" class="mr-2" color="primary" @click="onClickBack">Назад</v-btn>
            </v-col>
        </v-row>
          <v-row>
              <v-col cols="12" v-if="0 < uploadFileErrors.length">
                  <social-debtors-upload-error v-if="0 < uploadFileErrors.length" :errors="uploadFileErrors"></social-debtors-upload-error>
              </v-col>
              <v-col cols="12" v-if="debtorsUploadId">
                  <social-debtors-upload-table
                          :init-debtors="tableItems"
                          :init-house-address-objects="houseAddressObjects"
                          :init-disable-upload-debtors-btn="isFetchExecute"
                          :init-normalize-btn="isFetchExecute"
                          :init-identify-address-btn="isFetchExecute"
                          :init-item-errors="identifyHouseAddressErrors"
                          @inputHouseAddressObject="onInputHouseAddressObject"
                          @clickUploadDebtorsBtn="onUploadDebtors"
                          @clickNormalizeBtn="onNormalize"
                          @clickIdentifyAddressBtn="onClickIdentifyAddressBtn"
                  ></social-debtors-upload-table>
              </v-col>
          </v-row>
      </v-card-text>
  </v-card>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';
import {mapActions} from 'vuex';
import SocialDebtorsUploadForm from "../../components/debtors/SocialDebtorsUploadForm.vue";
import SocialDebtorsUploadError from "../../components/debtors/SocialDebtorsUploadError.vue";
import SocialDebtorsUploadTable from "../../components/debtors/SocialDebtorsUploadTable.vue";
import {downloadFile} from "../../../plugins/utils";
export default {
    name: "SocialDebtorsUploadPage",
    components: {SocialDebtorsUploadTable, SocialDebtorsUploadError, SocialDebtorsUploadForm},
    props:{
    },
    data(){
        return {
            dialogAddAddress: false,
            isFetchExecute: false,
            uploadFileErrors: [],
            uploadFileDebtors: [],
            houseAddressObjects: [],
            identifyHouseAddressErrors: []
        }
    },
    created() {},
    watch:{
        $route (to){
            if(to.params.id){
                this.loadUpload();
            }
        }
    },
    methods:{
        ...mapActions('uploadDebtors', ['getUpload', 'getTemplate', 'execute', 'normalize', 'identifyHouseAddress']),
        onClickBack(){
            this.uploadFileErrors.splice(0, this.uploadFileErrors.length);
            this.uploadFileDebtors.splice(0, this.uploadFileDebtors.length);
            this.houseAddressObjects.splice(0, this.houseAddressObjects.length);
            this.identifyHouseAddressErrors.splice(0, this.identifyHouseAddressErrors.length);
            this.$router.push({name: 'SocialDebtorsUploadPage'});
        },
        onAddedAddress(){
            console.log('onAddedAddress');
        },
        async onClickIdentifyAddressBtn(){
          try {
            this.isFetchExecute = true;
            let {data} = await this.identifyHouseAddress({id: this.$route.params.id});
            this.identifyHouseAddressErrors.splice(0, this.identifyHouseAddressErrors.length, ...data.errors);
            this.loadUpload();
          }catch (e) {
            console.log(e);
          }finally {
            this.isFetchExecute = false;
          }
        },
        async onNormalize(){
          try {
            this.isFetchExecute = true;
            await this.normalize({id: this.$route.params.id});
            this.loadUpload();
          }catch (e) {
            console.log(e);
          }finally {
            this.isFetchExecute = false;
          }
        },
        async onUploadDebtors(){
            try {
                this.isFetchExecute = true;
                let houseAddressObjects = this.uploadFileDebtors.map((elem) => {
                    return {id: elem.id, houseAddressObjectId: elem.houseAddressObjectId}
                });
                await this.execute({id: this.$route.params.id, data: {houseAddressObjects}});
                this.loadUpload();
            }catch (e) {
                console.log(e);
            }finally {
                this.isFetchExecute = false;
            }
        },
        onInputHouseAddressObject(e){
            let uploadFileDebtor = this.uploadFileDebtors.find((elem) => elem.id === e.uploadId);
            if(uploadFileDebtor){
                uploadFileDebtor.houseAddressObjectId = e.houseAddressObjectId;
            }
        },
        onDownloadTemplate(){
            this.getTemplate().then(({data}) => downloadFile(data, 'Шаблон.xlsx'));
        },
        onUpload(e){
            if(e.housePersonDebtorUploadId){
              this.$router.push({name: 'SocialDebtorsUploadPage', params: {id: e.housePersonDebtorUploadId}}).then(() => {
                  this.uploadFileErrors.splice(0, this.uploadFileErrors.length, ...e.errors);
                  this.loadUpload();
              });
            }
        },

        async loadUpload(){
            let {data} = await this.getUpload({id: this.$route.params.id});
            this.uploadFileDebtors.splice(0, this.uploadFileDebtors.length, ...data.items);
            this.houseAddressObjects.splice(0, this.houseAddressObjects.length, ...data.houseAddressObjects);
        }
    },
    computed: {
      tableItems(){
          return this.uploadFileDebtors.map((item) => {
              return {
                ...item.upload,
                id: item.id,
                houseAddressObjectId: item.houseAddressObjectId,
                status: item.result.status,
                addressNormalize: item.addressNormalize
              }
          })
      },
      debtorsUploadId(){
          return this.$route.params.id;
      }
    }
}
</script>

<style scoped>

</style>